import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

const CATEGORY_LABELS = {
  "storage-boxes": "Storage Boxes",
  "display-cases": "Display Cases",
  "shoe-care": "Shoe Care",
};

export const ProductCard = ({ product, index }) => {
  const { addItem } = useCart();
  const out = product.stock <= 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.06, duration: 0.4 }}
      data-testid={`product-card-${product.id}`}
      className="group border border-border/60 bg-white flex flex-col"
    >
      <Link to={`/product/${product.id}`} data-testid={`product-link-${product.id}`} className="bg-secondary aspect-square overflow-hidden relative block">
        {product.image_url ? (
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs uppercase tracking-widest">
            No Image
          </div>
        )}
        {out && (
          <div className="absolute inset-0 bg-white/70 flex items-center justify-center">
            <span data-testid={`product-sold-out-${product.id}`} className="bg-foreground text-white text-xs px-3 py-1 uppercase tracking-widest">Sold Out</span>
          </div>
        )}
      </Link>
      <div className="p-5 flex flex-col gap-2 flex-1">
        <span className="text-xs uppercase tracking-widest text-muted-foreground">{CATEGORY_LABELS[product.category] || product.category}</span>
        <Link to={`/product/${product.id}`} className="hover:text-primary transition-colors">
          <h3 data-testid={`product-name-${product.id}`} className="font-display font-semibold text-lg leading-tight">{product.name}</h3>
        </Link>
        {product.description && <p className="text-sm text-muted-foreground line-clamp-2">{product.description}</p>}
        <div className="mt-auto pt-3 flex items-center justify-between">
          <span data-testid={`product-price-${product.id}`} className="font-display font-semibold text-lg">${product.price.toFixed(2)}</span>
          <button
            data-testid={`add-to-cart-${product.id}`}
            disabled={out}
            onClick={() => {
              addItem(product);
              toast.success(`${product.name} added to cart`);
            }}
            className="flex items-center gap-1 bg-foreground text-white px-3 py-2 text-xs font-medium uppercase tracking-wider hover:bg-primary transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <Plus size={14} /> Add
          </button>
        </div>
      </div>
    </motion.div>
  );
};
